import { useMutation } from "@tanstack/react-query";
import { HTTP_ENDPOINTS } from "../../consts/api";
import { http } from "../../services/HttpService";

export const useEfaxCheckPagesMutation = (options = {}) => {
  return useMutation(
    (attachments) => {
      const formData = new FormData();
      attachments.forEach((file) => {
        formData.append("attachments[]", file);
      });
      return http.post(HTTP_ENDPOINTS.efax.checkPages(), formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
    },
    {
      ...options,
    },
  );
};
